import type {IntervalValue, ScoreLabel, ScoreType} from './types';

export const INTERVAL_ITEMS: Array<{key: IntervalValue; label: string}> = [
  {key: 7, label: '۷ روز گذشته'},
  {key: 15, label: '۱۵ روز گذشته'},
  {key: 30, label: '۳۰ روز گذشته'}
];

export const DAYS_OF_WEEK = ['ی', 'د', 'س', 'چ', 'پ', 'ج', 'ش'];

export const SCORE_LABELS: Record<ScoreLabel, string> = {
  VERY_GOOD: 'عالی',
  GOOD: 'خوب',
  WEAK: 'ضعیف',
  VERY_WEAK: 'خیلی ضعیف'
};

export const SCORE_TITLES: Record<ScoreType, string> = {
  penetration: 'تنوع کالایی',
  atp: 'موجودی',
  ptk: 'قیمت عادلانه'
};

export const PRODUCT_SCORE_TREND_TEXT: Record<ScoreType, Record<ScoreLabel, string>> = {
  penetration: {
    VERY_GOOD:
      'تبریک! شما کالاهای پرفروش منطقه خود را به خوبی تامین کرده‌اید و اقلام پرتقاضای منطقه، در حال حاضر در فروشگاه شما موجود هستند. با ادامه این روند، سهمتان را از فروش منطقه خود افزایش دهید.',
    GOOD: 'شما درصد قابل قبولی از کالاهای پرفروش منطقه خود را موجود دارید! با توجه و بررسی مداوم این شاخص، از تامین کافی کالاهای پرتقاضا در منطقه خود اطمینان حاصل نموده و سهم خود را در فروش منطقه بالاتر ببرید.',
    WEAK: 'شما تعداد زیادی از محصولات پرفروش منطقه را موجود ندارید! با تامین به‌موقع و کافی این محصولات، از فروشگاه‌های اطراف جا نمانید و سهم فروشتان را از کالاهای پرتقاضای منطقه خود بالا ببرید.',
    VERY_WEAK:
      'هشــدار! شما در تامین کالاهای پرفروش منطقه عملکرد ضعیفی دارید! با توجه به پرتقاضا بودن این اقلام در منطقه شما، عدم تامین به موقع و کافی این محصولات، منجر به از دست دادن سفارشات زیادی در فروشگاه شما شده است. با بررسی و افزایش فوری موجودی این اقلام، مشتریان بیشتری جذب کرده و به سهم فروش رقبا نزدیک شوید!'
  },
  atp: {
    VERY_GOOD:
      'تبریک! شما کالاهای پرفروش خود را به خوبی تامین کرده‌اید و در حال حاضر پرفروش‌ترین اقلام سفارشات گذشته شما، در فروشگاهتان موجود است. با ادامه این روند، فروش و رضایت مشتریان خود را حفظ کرده و بهبود دهید.',
    GOOD: 'شما درصد قابل قبولی از کالاهای پرفروش فروشگاه خود را موجود دارید! با توجه و بررسی مداوم این شاخص، از تامین کافی کالاهای پرتقاضا در فروشگاه خود اطمینان حاصل نموده و فروش خود را بالاتر ببرید.',
    WEAK: 'تعداد زیادی از محصولات پرفروش فروشگاه خود را موجود ندارید! با تامین بموقع و کافی این محصولات، رضایت مشتریان را جلب نموده و از کاهش فروش خود، جلوگیری کنید.',
    VERY_WEAK:
      'هشـــدار! کالاهای پرفروش در سفارشات گذشته‌تان، هم اکنون در فروشگاه شما موجود نیستند! عدم تامین فوری این محصولات، منجر به کاهش شدید فروش و نارضایتی مشتریان شده و افت قابل توجه جایگاه فروشگاه شما را به دنبال خواهد داشت.'
  },
  ptk: {
    VERY_GOOD:
      'تبریک! شما قیمت‌گذاری منصفانه‌ای بر روی محصولات فروشگاه خود داشته‌اید. قیمت‌های بروز و استاندارد، تاثیر قابل توجهی در جلب رضایت و جذب مشتریان بیشتر خواهد داشت. با حفظ این روند، فروش خود را افزایش داده و مشتریان وفادار پیدا کنید.',
    GOOD: 'قیمت‌گذاری شما بر روی بیشتر محصولات، منصفانه است. با رقابتی نگه داشتن قیمت‌ها، مشتریان بیشتری جذب کنید و فروش خود را افزایش دهید.',
    WEAK: 'قیمت‌گذاری شما بر روی بسیاری از محصولات، منصفانه و استاندارد نیست! فروشگاه‌های اطراف شما، این محصولات را با قیمت مناسب‌تری ارائه می‌کنند. با بررسی و اصلاح قیمت‌ها، فروش خود را افزایش داده و اعتماد مشتریان را جلب کنید.',
    VERY_WEAK:
      'هشــدار! شما در قیمت‌گذاری کالاها، عملکرد منصفانه‌ای ندارید! عدم ارائه محصولات با قیمت منصفانه، باعث از دست رفتن اعتماد مشتریان و عدم انتخاب فروشگاه شما برای خرید می‌شود. با اصلاح فوری قیمت‌ها، از کاهش فروش خود جلوگیری کنید.'
  }
};
